import React from 'react';
import { ROOT_CATEGORIES } from '../../gql/categories';
import { CategoryItemNode } from '../../shared/types';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { ExtendedTheme, Heading } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/core';
import LinkList, { ListItemOrientation, ListItemType } from '../ui/LinkList';
import { useOnDataLoaded } from '../hooks/use-on-data-loaded';
import { baseUrls } from '../../utils/baseUrls.utils';
import { topicsOrCategories } from '../../utils/utils';

const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) => createStyles({
	catList: {
		margin: `${theme.spacing(2)}px 0`
	},
	link: {
		display: 'flex',
		alignItems: 'center',
		fontWeight: 'bold'
	},
	linkWrapper: {
		display: 'flex'
	},
	rightArrow: {
		width: 10,
		marginLeft: theme.spacing(1.1),
		fontWeight: 'bold'
	}
}));

export interface BrowseCategoryListProps {
	browsePage?: boolean;
	parentCategoryName?: string;
	categories?: {
		_id: string;
		name: string;
	}[];
	onDataLoaded?: () => void;
}

export const BrowseCategoryList = ({ categories = [], parentCategoryName = '', browsePage = false, onDataLoaded }: BrowseCategoryListProps): JSX.Element => {
	const classes = useStyles();
	const { categoryId } = useParams();
	const queryCategories = useQuery(
		ROOT_CATEGORIES,
		{
			fetchPolicy: 'network-only',
			variables: !browsePage ? {
				id: categoryId
			} : {},
			skip: !browsePage
		}
	);
	useOnDataLoaded(queryCategories.loading, onDataLoaded);

	if (queryCategories.loading) return <></>;

	const categoryList: CategoryItemNode[] =
		!browsePage
			? categories
			: queryCategories.data?.rootCategories;

	//TODO uncomment this part of code once the categories page been ready
	// const url = !browsePage ? `categories/${categoryId}` : 'categories';

	if (!categoryList?.length) {
		return <></>;
	}

	return (
		<div>
			<div
				id={'article-page-category-browse'}
				className={classes.item}
			>
				<Heading
					styleName="title1"
					xs="small"
					md="medium"
					xl="large"
				>
					{
						!browsePage ?
							`More in ${parentCategoryName}` :
							`Browse ${topicsOrCategories(true)}`
					}
				</Heading>
			</div>
			<div className={classes.catList}>
				<LinkList
					items={(categoryList || []).map((category) => ({
						id: category._id,
						name: category.name,
						url: `${baseUrls.browse.main}/${category._id}`
					}))}
					orientation={ListItemOrientation.Horizontal}
					displayType={ListItemType.Chip}
					chipVariant={'info'}
				/>
			</div>
			{/* //TODO uncomment this part of code once the categories page been ready */}
			{/*<div className={classes.linkWrapper}>*/}
			{/*	<Link*/}
			{/*		className={classes.link}*/}
			{/*		to={url}*/}
			{/*		//TODO remove this after the URL above been defined*/}
			{/*		onClick={(e) => e.preventDefault()}*/}

			{/*	>*/}
			{/*		See all categories*/}
			{/*		<ArrowsChevronRight className={classes.rightArrow}/>*/}
			{/*	</Link>*/}
			{/*</div>*/}
		</div>
	);
};

export default BrowseCategoryList;
